// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main___Xfeh","section":"index_section__7QO2_"};